<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR EQUIPOS DE PROCESO</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>

            <data-table class="mt-5" @editar="editar($event)"></data-table>

            <modal @peticionrealizada="cargarDatos"></modal>
    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
// import axios from 'axios'
export default {
    data:()=>({
        // ajustes:{
        //     columnas:[
        //         {key:'tipo_equipo',titulo:'Tipo de Equipo',visible:true,filtro:{visible:true,orden:'ASC'},path:'tipo_equipo',tipo:'texto'}
        //     ],
        //     acciones:[
        //         {key:'editar',titulo:'Editar',visible:true}
        //     ]
        // },
        lista:[],
        tipos_equipo:[],
        inputs:[
            {tipo:'texto',valor:'',label:'Nombre de Equipo*',key:'nombre_equipo'},
            {tipo:'texto',valor:'',label:'Nombre Corto*',key:'nombre_corto'},
            {tipo:'select',valor:'',label:'Seleccione Tipo de Equipo*',key:'tipo_equipos_id',opciones:[],texto:'tipo_equipo',seleccion:'id'},
            {tipo:'numero',valor:0,label:'Orden*',key:'orden'}
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
                {
                    text:'Orden',
                    align:'center',
                    sortable:true,
                    filterable:true,
                    value:'orden',
                    class: 'cabecera',
                },
                {
                    text: 'Tipo Equipos',
                    align: 'center',
                    sortable: true,
                    value: 'tipo_equipos_nombre',
                    class: 'cabecera',
                },
                {
                    text: 'Nombre',
                    align: 'center',
                    sortable: true,
                    value: 'nombre_equipo',
                    class: 'cabecera',
                },
                {
                    text: 'Nombre Corto',
                    align: 'center',
                    sortable: true,
                    value: 'nombre_corto',
                    class: 'cabecera',
                },
                { text: 'Acciones', value: 'action', sortable: false, align:'center',class: 'cabecera', },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarTiposEquipo();
    },
    methods: {
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...');
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}equipo_procesos`;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                const data = response.data.data;
                this.lista = data.map(item => {
                    const tipo = this.tipos_equipo.find(t => t.id === item.tipo_equipos_id);
                    return {
                        ...item,
                        tipo_equipos_nombre: tipo ? tipo.tipo_equipo : 'Sin Tipo'
                    };
                });
                // response.data.data.forEach(item => {
                //     this.lista.push({id:item.id,tipo_equipo:item.tipo_equipo})
                // });
                Event.$emit('actualizar_lista',this.lista);
                Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones);
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarTiposEquipo(){
            //this.mostrarLoading('Cargando Tipos de Equipo...');
            this.mostrarLoading({titulo:'Cargando Tipos de Equipo...',color:'green'})

            let url = `${this.base_url}tipo_equipos`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.inputs[2].opciones = response.data.data;
                this.tipos_equipo = response.data.data;
                this.cargarDatos();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Equipo de Proceso';
            this.configuracion_modal.boton_submit = 'Crear';
            this.configuracion_modal.ruta = 'equipo_procesos';
            this.configuracion_modal.tipo_peticion = 'POST';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor;
                    }
                });
            });
            
            let tipo_equipo = await this.$buscarObjeto($event['tipo_equipos_id'],this.tipos_equipo);
            this.inputs[2].valor = tipo_equipo;

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Equipo';
            this.configuracion_modal.boton_submit = 'Actualizar';
            this.configuracion_modal.ruta = `equipo_procesos/${$event.id}`;
            this.configuracion_modal.tipo_peticion = 'PUT';
            this.$emit('abrir',this.inputs,this.configuracion_modal);
            console.log('inputs',this.inputs);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading']),
    },
    computed: {
        ...mapState(['base_url','headers']),
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table
    }
}
</script>
<style scoped>
    .titulo2{color: white !important; font-size: 1em !important; }
</style>